import { createUseStyles } from "react-jss";
import {colors} from "../../../../../constants/colors";

const styles = createUseStyles(theme => ({
  noRecordsWrapper: {
    padding: "0px 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    margin: "24px 0px",
    maxWidth: "350px",
  },
  title: {
    color: colors.lightBlack,
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 600,
    marginTop: "16px",
  },
  subtitle: {
    color: colors.mediumGrey,
    textAlign: "center",
    fontSize: "14px",
    fontWeight: 400,
    margin: "4px 0px 24px 0px",
  }
}));

export default styles;
